import { action, computed, observable } from "mobx";
import { ICard } from "types/card";
import { gba } from "util/georgeBusinessAdapter";

export type PinResetError = "FeeNotFound";

/**
 * Infos for a single card
 */
export class CardsStore {
    filterFor?: string;

    @observable isLoading: boolean = false;
    @observable cards?: ICard[];
    @observable selectedCard?: ICard;
    @computed get selectedCardId(): string | undefined {
        return this.selectedCard ? this.selectedCard.id : undefined;
    }

    set selectedCardId(id: string | undefined) {
        this.selectedCard = this.cards ? this.cards.find(c => c.id === id) : undefined;
    }

    constructor(filterFor?: string) {
        this.filterFor = filterFor;
    }

    /**
     * For feature test: Only show cards that support features of the hybrid app
     */
    @action filterSupportedCards() {
        if (this.cards && this.cards.length > 0) {
            // this.cards = this.cards.filter(
            //     card =>
            //         card.features && card.features.indexOf("displayPin") >= 0 // Cards with displayPin
            //         || card.type === "CREDIT" // Credit cards
            //         || card.type === "PREPAID" // Prepaid cards
            // );

            this.selectedCard = this.cards[0];
        }
    }

    @action async load() {
        try {
            this.isLoading = true;
            this.cards = await gba.getCards(this.filterFor);
            if (this.cards && this.cards.length > 0) {
                this.selectedCard = this.cards[0];
            }
        } finally {
            this.isLoading = false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/stores/CardsStore.ts